



export const SidebarData1 = [
  {
    tittle: 'Dashboard',
    hasSubRoute: false,
    icon: 'layout-grid',
    showSubRoute: false,
    route: '/dashboard',
    subRoutes: []
  },
    {
    tittle: 'Rollcall Status',
    hasSubRoute: true,
    icon: 'user-check',
    showSubRoute: false,
    route: 'rollcallstatus',
    subRoutes: [
      {
        tittle: 'Rc Health Check',
        hasSubRoute: false,
        icon: 'user-check',
        showSubRoute: false,
        route: '/health-check',
        subRoutes: []
      },
      {
        tittle: 'Raw Swipes',
        hasSubRoute: false,
        icon: 'circle-plus',
        showSubRoute: false,
        route: "/raw-swipes",
        subRoutes: []
      },
       {
        tittle: 'Mobile Users',
        hasSubRoute: false,
        icon: 'users-group',
        showSubRoute: false,
        route: "/mobile-users",
        subRoutes: []
      },
      {
        tittle: 'EssPortalPage',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/rollcallesslogin",
        subRoutes: [],
      },
      {
        tittle: 'RCAdminPage',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/rollcalladminlogin",
        subRoutes: [],
      },

      
    ]
  },
  {
    tittle: 'Clients & Devices',
    hasSubRoute: true,
    icon: 'users',  
    showSubRoute: false,
    activeRoute: 'product',
    subRoutes: [
      {
        tittle: 'Clients',
        hasSubRoute: false,
        showSubRoute: true,
        route: "/companies",
        subRoutes: [],
      },
      {
        tittle: 'Devices',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/devices",
        subRoutes: [],
      },
      {
        tittle: 'Renewals',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/renewals",
        subRoutes: [],
      },
      {
        tittle: 'InActive Clients',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/inactive-clients",
        subRoutes: [],
      },
      {
        tittle: 'Key Generation',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/key-genrations",
        subRoutes: [],
      },
    ],
  },
    
  // {
  //   tittle: 'RollCall',
  //   hasSubRoute: true,
  //   icon: 'user-check',
  //   showSubRoute: false,
  //   activeRoute: 'rollcall',
  //   subRoutes: [
  //     {
  //       tittle: 'Raw Swipes',
  //       hasSubRoute: false,
  //       showSubRoute: true,
  //       route: "/raw-swipes",
  //       subRoutes: [],
  //     },
  //     {
  //       tittle: 'Mobile Users',
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       route: "/mobile-users",
  //       subRoutes: [],
  //     },
  //     // {
  //     //   tittle: 'View Clients Status',
  //     //   hasSubRoute: false,
  //     //   showSubRoute: false,
  //     //   route: "/dashboard",
  //     //   subRoutes: [],
  //     // },
  //   ],
  // },
   {
    tittle: 'Others',
    hasSubRoute: true,
    icon: 'chart-bar',
    showSubRoute: false,
    activeRoute: 'others',
    subRoutes: [
      // {
      //   tittle: 'Notifications',
      //   hasSubRoute: false,
      //   showSubRoute: true,
      //   route: "/dashboard",
      //   subRoutes: [],
      // },
      {
        tittle: 'Jobs',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/jobs",
        subRoutes: [],
      },
      {
        tittle: 'Job Status',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/jobs-status",
        subRoutes: [],
      },
       {
        tittle: 'Query',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/query",
        subRoutes: [],
      },
       {
        tittle: 'DB Health',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/dbhealth",
        subRoutes: [],
      },
       {
        tittle: 'SMS',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/sms",
        subRoutes: [],
  },
  {
    tittle: 'DemoApplicationView',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/demoapplicationviewlist",
    subRoutes: [],
},
],
},

{
  tittle: 'Login Pages',
  hasSubRoute: true,
  icon: 'ti ti-login',
  showSubRoute: false,
  activeRoute: 'loginpages',
  subRoutes: [
 
   
    {
      tittle: 'IbizLoginPage',
      hasSubRoute: false,
      showSubRoute: false,
      route: "/ibizloginpage",
      subRoutes: [],
    },
  ]
}
  // {
  //   tittle: 'Main Menu',
  //   hasSubRoute: true,
  //   icon: 'layout-grid',
  //   showSubRoute: false,
  //   subRoutes: [
  //     {
  //       tittle: 'Dashboard',
  //       hasSubRoute: true,
  //       showSubRoute: true,
  //       subRoutes: [
  //         {
  //           tittle: 'Admin Dashboard',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/index",
  //           subRoutes: [],
  //         },
  //         {
  //           tittle: 'Admin Dashboard 2',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/admin-dashboard",
  //           subRoutes: [],
  //         },
  //         {
  //           tittle: 'Sales Dashboard',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/sales-dashboard",
  //           subRoutes: [],
  //         },
  //       ],
  //     },
  //     {
  //       tittle: 'Super Admin',
  //       hasSubRoute: true,
  //       showSubRoute: true,
  //       subRoutes: [
  //         {
  //           tittle: 'Dashboard',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/dashboard",
  //           subRoutes: [],
  //         },
  //         {
  //           tittle: 'Companies',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/companies",
  //           subRoutes: [],
  //         },
  //         {
  //           tittle: 'Subscriptions',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/subscription",
  //           subRoutes: [],
  //         },
  //         {
  //           tittle: 'Packages',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/packages",
  //           subRoutes: [],
  //         },
  //         {
  //           tittle: 'Domain',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/domain",
  //           subRoutes: [],
  //         },
  //         {
  //           tittle: 'Purchase Transaction',
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           route: "/purchase-transaction",
  //           subRoutes: [],
  //         },
  //       ],
  //     },

];
